/**
 * Customer-facing labels for receipting edit types.
 *
 * Raw enum values (e.g. `invoice_reconciliation`) are internal API/database
 * values and must never be rendered to users. Any unknown value gets a safe
 * generic fallback instead of leaking the raw string.
 */
export const RECEIPTING_EDIT_TYPE_LABELS = {
  credit_note_request: 'Credit requested',
  invoice_reconciliation: 'Review during invoice reconciliation',
}

export const RECEIPTING_EDIT_TYPE_FALLBACK = 'Update recorded'

/**
 * @param {string|undefined|null} editType raw internal value
 * @param {object} [options]
 * @param {string} [options.fallback] label used when the value is unknown
 * @returns {string} customer-facing label (never the raw enum)
 */
export function getReceiptingEditTypeLabel(editType, options = {}) {
  const raw = editType == null ? '' : String(editType).trim()
  if (!raw) return ''
  const fallback = options.fallback || RECEIPTING_EDIT_TYPE_FALLBACK
  return RECEIPTING_EDIT_TYPE_LABELS[raw] || fallback
}
